import React, { useState } from 'react';

import { Box, Grid, Typography, Modal } from '@mui/material';
import { callApi } from 'src/core/callApi';
import { COLOR_PRIMARY, COLOR_RED } from 'src/const';
import { ToastContainer, toast, ToastOptions } from 'react-toastify';

import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import MarkEmailUnreadIcon from '@mui/icons-material/MarkEmailUnread';
import CloseIcon from '@mui/icons-material/Close';

// http://localhost:3000/verify/eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJlbWFpbCI6ImFybmF2KzEyMDBAYWlyYnRpY3MuY29tIiwiZXhwIjoxNjY2MDM1OTc2fQ.O7OM9NUL4HEiHJnE-E2QD_Oh3kjC5XFZEQW5S_CsUbw

const EmailVerifyModal = ({
  open,
  setOpen,
  email,
}: {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  email: string;
}) => {
  const [isEmailSentAgain, setIsEmailSentAgain] = useState<boolean>(false);
  const [isEmailSending, setIsEmailSending] = useState<boolean>(false);

  const sendVerificationEmail = async () => {
    const url = 'https://nucx2ebwi6.execute-api.us-east-2.amazonaws.com/default/verifyUser';
    const config = {
      queryParams: {
        action: 'generate_magic_link',
        email: encodeURIComponent(email),
      },
    };
    const resp: any = await callApi(url, config, false);
    if (resp.error) {
      makeAlert(resp.error.toString(), true);
      return;
    }
    setIsEmailSentAgain(true);
    makeAlert(resp.message);
  };

  const makeAlert = (text: string, isError = false) => {
    const options: ToastOptions = {
      autoClose: 500000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'colored',
    } as ToastOptions;
    if (!isError) {
      toast.success(text, options);
    } else {
      toast.error(text, options);
    }
    setIsEmailSending(false);
  };

  const handleRegenarateLink = () => {
    if (!isEmailSending) {
      setIsEmailSending(true);
      sendVerificationEmail();
    }
  };

  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <>
        <Box
          sx={{
            height: '70vh',
            width: '70vw',
            minWidth: '350px',
            maxWidth: '800px',
            overflow: 'auto',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 9000,
            background: '#fff',
            borderRadius: '4px'
          }}
        >
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            direction="column"
            spacing={3}
            sx={{ height: '70vh' }}
          >
            <Grid item justifyContent="center" sx={{ position: 'absolute', top: '10px' }}>
              <Typography variant="body2" sx={{ color: '#6B6B6B', textAlign: 'center' }}>
                Thank you for signing up !
              </Typography>
            </Grid>

            <Grid item justifyContent="center">
              {isEmailSentAgain ? (
                <MarkEmailReadIcon sx={{ fontSize: '100px', color: COLOR_PRIMARY }} />
              ) : (
                <MarkEmailUnreadIcon sx={{ fontSize: '100px', color: COLOR_PRIMARY }} />
              )}
            </Grid>

            <Grid item justifyContent="center">
              <Typography
                variant="h5"
                style={{ fontWeight: 'bold', fontSize: '24px', textAlign: 'center' }}
              >
                Please verify your email address
              </Typography>
            </Grid>

            <Grid item justifyContent="center" sx={{ width: '70%' }}>
              <Typography
                variant="body1"
                sx={{ color: '#6B6B6B', fontSize: '18px', textAlign: 'center' }}
              >
                {isEmailSentAgain
                  ? 'An email has been sent to your account. If you have already verified, please refresh the page.'
                  : 'Please click on the link sent to your email in order to verify your email address. If you have already verified, please refresh the page.'}
              </Typography>
            </Grid>

            {!isEmailSentAgain && (
              <Grid item justifyContent="center" sx={{ width: '70%' }}>
                <Typography variant="body1" sx={{ color: '#6B6B6B', textAlign: 'center' }}>
                  Didn’t get the link? click{' '}
                  <p
                    style={{
                      color: COLOR_PRIMARY,
                      cursor: isEmailSending ? 'wait' : 'pointer',
                      display: 'inline',
                      fontWeight: 'bold',
                    }}
                    onClick={handleRegenarateLink}
                  >
                    here
                  </p>{' '}
                  to get the link to your email.
                </Typography>
              </Grid>
            )}

            <Box
              sx={{
                position: 'absolute',
                top: '20px',
                right: '20px',
              }}
            >
              <CloseIcon
                onClick={() => setOpen(false)}
                sx={{ fontSize: '40px', cursor: 'pointer', color: COLOR_RED }}
              />
            </Box>
          </Grid>
        </Box>

        <ToastContainer position="bottom-left" newestOnTop style={{ marginTop: '40px' }} />
      </>
    </Modal>
  );
};

export default EmailVerifyModal;
